/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2025, Zumper
 * @description   stream token response bizos
 */

import { Bizo, autoclass } from './base'
import type {
  RawStreamTokenReponse,
  RawUnreadCounts,
  StreamTokenResponse as StreamTokenResponseType,
  UnreadCounts as UnreadCountsType,
} from './streamToken.types'

export const UnreadCounts: typeof UnreadCountsType = autoclass<UnreadCountsType, RawUnreadCounts>(
  'UnreadCounts',
  class UnreadCounts extends Bizo<UnreadCountsType, RawUnreadCounts> {},
  {
    landlordUnreadCount: 'landlord_unread_count',
    renterUnreadCount: 'renter_unread_count',
  }
)
export type UnreadCounts = UnreadCountsType

export const StreamTokenResponse: typeof StreamTokenResponseType = autoclass<
  StreamTokenResponseType,
  RawStreamTokenReponse
>(
  'StreamTokenResponse',
  class StreamTokenResponse extends Bizo<StreamTokenResponseType, RawStreamTokenReponse> {},
  {
    apiKey: 'api_key',
    streamId: 'stream_id',
    token: 'token',
    unreadCounts: { name: 'unread_counts', type: UnreadCounts },
  }
)
export type StreamTokenResponse = StreamTokenResponseType
